import React from 'react';
import { CardSwitchSC } from './card-switch.styled';

const CardSwitch = ({ children }) => {
  return <CardSwitchSC>{children}</CardSwitchSC>;
};

export default CardSwitch;
